import { PhoneVerificationState } from 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerification.reducers';
import { AppState } from 'mk2/reducers';

export const getUsersManualPhoneVerificationState = (state: AppState): PhoneVerificationState =>
    state.containers.users.manualPhoneVerification;
